import { render } from "./ProjectPage.vue?vue&type=template&id=0e7b8858&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=0e7b8858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7b8858"]])

export default __exports__